import { Button } from '@cropler/ui-kit';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

import styles from './styles.module.scss';

const CardNotes = ({ count, onClickNotes }) => {
  return (
    <Button
      className={styles.cardButton}
      type="secondary"
      icon={<CroplerIcon name="note" />}
      onClick={onClickNotes}
      size="large"
    >
      <span className={styles.cardButtonNumber}>{count}</span>
    </Button>
  );
};

export default CardNotes;
